import { type IGetSocialApplyResponse, useGetSocialApplySuspense } from "@api";
import type { IDocument } from "@bbj-types/document";
import type { PartnerDecision } from "@bbj-types/socialApply/enum";
import type { ObjectId } from "@bbj-types/utils";
import { FupPartnerForm } from "@candidate/views/forms/FupPartnerForm";
import CloseIcon from "@mui/icons-material/Close";
import { DialogContent, DialogTitle, IconButton, Stack, type Theme, Typography, useMediaQuery } from "@mui/material";
import { Dialog, SuspenseHandler } from "@styleguide";

interface IFupModalContentProps {
  getSocialApply: () => IGetSocialApplyResponse;
  onClose: (result?: { fupDocument: IDocument; decision: PartnerDecision }) => void;
}

const FupModalContent = ({ getSocialApply, onClose }: IFupModalContentProps) => {
  const socialApply = getSocialApply();
  const md = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  return (
    <Dialog
      open
      onClose={() => onClose()}
      slotProps={{
        paper: {
          sx: md ? { height: "700px", minWidth: "900px" } : undefined,
        },
      }}
      fullScreen={!md}
    >
      <DialogTitle component={Stack} direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4">Prescription pour une offre</Typography>
        <IconButton size="small" onClick={() => onClose()}>
          <CloseIcon fontSize="medium" color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FupPartnerForm socialApply={socialApply} onSendFup={onClose} />
      </DialogContent>
    </Dialog>
  );
};

interface IFupModalProps {
  socialApplyId: ObjectId;
  onClose: (result?: { fupDocument: IDocument; decision: PartnerDecision }) => void;
}

export const FupModal = ({ socialApplyId, onClose }: IFupModalProps) => {
  const getSocialApply = useGetSocialApplySuspense(socialApplyId);

  return (
    <SuspenseHandler redirect="/partners/structure/dashboard" slotProps={{ box: { height: "100%" } }}>
      <FupModalContent getSocialApply={getSocialApply} onClose={onClose} />
    </SuspenseHandler>
  );
};
